export default [
	{
		path: '/pricing',
		name: 'pricing',
		component: () => import(/* webpackChunkName: 'Pricing' */ './Pricing.vue'),
		props: true
	},
	{
		path: '/organization/selectplan',
		name: 'selectplan',
		component: () => import(/* webpackChunkName: 'SelectPlan' */ './SelectPlan.vue'),
		props: true,
		meta: {
			auth: 'required'
		}
	}
];